import React, { useRef, useState } from 'react';
import copy from 'copy-to-clipboard';
import { ClickAwayListener, Tooltip } from '@mui/material';
import FlatIcon, { FlatIconOptions } from '../FlatIcon';

function CopyClipboard({ value, color = '#31b7bc', style = {}, displayValue = true }) {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);

  const copied = (text) => {
    if (!text) return;
    copy(text);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setOpen(true);
    timeoutRef.current = window.setTimeout(() => {
      setOpen(false);
      timeoutRef.current = null;
    }, 2000);
  };

  const handleClickAway = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setOpen(false);
  };

  return (
    <div
      style={{
        ...style,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}>
      {displayValue && <span style={{ wordBreak: 'break-all' }}>{value}</span>}
      {value && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <Tooltip
            PopperProps={{ disablePortal: true }}
            open={open}
            onClose={() => setOpen(false)}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title='Copiado.'>
            <button
              onClick={() => copied(value)}
              style={{
                background: 'transparent',
                border: 'none',
                padding: 4,
                cursor: 'pointer',
                marginLeft: 2,
              }}
              aria-label='copiar'>
              <FlatIcon
                icon={FlatIconOptions.copy}
                style={{ color: color }}
                size={ style?.fontSize || 8 }
              />
            </button>
          </Tooltip>
        </ClickAwayListener>
      )}
    </div>
  );
}

export default CopyClipboard;
